import { render, staticRenderFns } from "./KioskHomeV2.vue?vue&type=template&id=d84db188&scoped=true"
import script from "./KioskHomeV2.vue?vue&type=script&lang=js"
export * from "./KioskHomeV2.vue?vue&type=script&lang=js"
import style0 from "./KioskHomeV2.vue?vue&type=style&index=0&id=d84db188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84db188",
  null
  
)

export default component.exports